export default {
  name: 'Call to action section - 3',
  tab: 'call to action',
  type: 'content-side-by-syde-section',
  content: {
    title: 'Call to action',
    introtext:
      '<p>Aenean eu leo quam. Pellentesque ornare sem lacinia quam venenatis vestibulum. Maecenas sed diam eget risus varius blandit sit amet non magna.</p><p>Nullam quis risus eget urna mollis ornare vel eu leo. Maecenas faucibus mollis interdum.&nbsp;</p>',
    image: '/storage/media/samples/erol-ahmed-_MYcIi9DgYQ-unsplash.jpg',
    buttons:
      '[{"button-text":"Call to action","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'inherit',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'inherit'
  },
  layout: {
    'content-container-fluid': '0',
    container: '1',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-vertical-alignment': 'center',
    'image-size': 'lg',
    'image-position': 'left',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0',
    'content-box-border-color': 'inherit'
  },
  advanced: {}
}
